import React from "react";
import HeroSection from "./GIS/HeroSection";
import MagicBento from "./GIS/MagicBento";
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const GISMain = () => {
  return (
    <div>
      <HeroSection />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </div>
  );
};

export default GISMain;
